module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('admin-header', {
    attrs: {
      "title": 'User Groups',
      "uploader": true
    },
    on: {
      "open-filter": _vm.openFilter,
      "entity-quick-search": _vm.search,
      "create-entity-request": _vm.goToNewEntityScreen,
      "csv-upload": _vm.multiSave
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "admin-content"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b968884"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/UserGroup/AdminUserGroup.vue
// module id = 2112
// module chunks = 1